import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { BodyTextMedium, TitleTextSmall } from 'Packages/FacetDesign/Components';
import PropTypes from 'prop-types';

const CapitalizeLabeledInfo = ({ label, value }) => {
  return (
    <FDStack direction={'column'}>
      <TitleTextSmall value={<strong>{label}</strong>} color={'textPrimary'} />
      <BodyTextMedium value={value} />
    </FDStack>
  );
};

CapitalizeLabeledInfo.defaultProps = {
};

CapitalizeLabeledInfo.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CapitalizeLabeledInfo;
